<template>
  <div class="condition-title">
    <div class="search-condition">
      <div class="search-condition__text">
        <slot name="title"></slot>
      </div>
      <div class="search-condition__count">
        <slot name="count"></slot>
      </div>
    </div>
    <div class="action">
      <slot name="action"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'condition-title'
};
</script>
<style lang="scss" scoped>
.condition-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 24px;

  .search-condition {
    display: flex;
    align-items: center;

    &__text {
      font-stretch: normal;
      font-style: normal;
      letter-spacing: normal;
      text-align: left;
      font-size: 16px;
      font-weight: 500;
      line-height: 16px;
      color: #2e3138;
    }
    &__count {
      margin-left: 4px;
    }
  }

  .action {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    :deep(.dropdown .anchor){
      height: 20px;
    }
  }
}
</style>
